module.exports = __webpack_public_path__ + "img/tokens.4505b47e.svg";